import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { tap } from 'rxjs/operators';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { PaymentsService } from 'src/app/services/payments-services/payments.service';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';

@Component({
  selector: 'app-catalogs-config-dashboard',
  templateUrl: './catalogs-config-dashboard.component.html',
  styleUrls: ['./catalogs-config-dashboard.component.scss']
})
export class CatalogsConfigDashboardComponent implements OnInit, OnDestroy {

  banner;
  primaryColor;
  secondaryColor;
  inactivityTime;
  assistanceActive;
  gateways;
  services;
  mcatalogGateways;
  tickets;
  customerTicket;
  staffTicket;
  getGatewaysSubscription: Subscription;
  refreshMCatalogConfigSubscription: Subscription;
  getMCataloGatewaysSubscription: Subscription;
  getMCatalogConfigSubscription: Subscription;
  getServicesSubscription: Subscription;
  getTicketsSubscription: Subscription;

  constructor(private paymentsService: PaymentsService,
              private ticketsService: TicketsService,
              private mcatalogConfigService: McatalogConfigService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.refreshMCatalogConfigSubscription = this.mcatalogConfigService.listenRefreshMCatalogConfig().subscribe(
      (res) => {
        this.getGateways();
        this.getMCatalogServices();
        this.getMCatalogGateways();
        this.getMCatalogConfig();
        this.getTickets();
      }
    );
    this.getGateways();
    this.getMCatalogServices();
    this.getMCatalogGateways();
    this.getMCatalogConfig();
    this.getTickets();
    this.setBreadcrumb();
  }

  private getGateways() {
    this.getGatewaysSubscription = this.paymentsService.getGateways().pipe(
      tap(o => this.gateways = o && (o.length > 0) ? o.filter(g => g.Active) : o)
    ).subscribe();
  }

  private getMCatalogServices() {
    this.getServicesSubscription = this.mcatalogConfigService.getMCatalogServices().pipe(
      tap(o => this.services = o)
    ).subscribe();
  }

  private getMCatalogConfig() {
    this.getMCatalogConfigSubscription = this.mcatalogConfigService.getMCatalogConfig().pipe(
      tap(o => this.banner = o['banner']),
      tap(o => this.primaryColor = o['primaryColor']),
      tap(o => this.secondaryColor = o['secondaryColor']),
      tap(o => this.customerTicket = o['ticketCustomer']),
      tap(o => this.staffTicket = o['ticketStaff']),
      tap(o => this.inactivityTime = o['inactivityTime']),
      tap(o => this.assistanceActive = o['assistanceActive'])
    ).subscribe();
  }

  private getMCatalogGateways() {
    this.getMCataloGatewaysSubscription = this.mcatalogConfigService.getMCatalogGateways().pipe(
      tap(o => this.mcatalogGateways = o)
    ).subscribe();
  }
  private getTickets() {
    this.getTicketsSubscription = this.ticketsService.getTicketList().pipe(
      tap(o => this.tickets = o)
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-cogs', 'catalogs-page.config', '/catalog', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.config')]));
  }

  ngOnDestroy() {
    if (this.getGatewaysSubscription) { this.getGatewaysSubscription.unsubscribe(); }
    if (this.getMCataloGatewaysSubscription) { this.getMCataloGatewaysSubscription.unsubscribe(); }
    if (this.refreshMCatalogConfigSubscription) { this.refreshMCatalogConfigSubscription.unsubscribe(); }
    if (this.getMCatalogConfigSubscription) { this.getMCatalogConfigSubscription.unsubscribe(); }
    if (this.getTicketsSubscription) { this.getTicketsSubscription.unsubscribe(); }
  }
}
